<template>
<alerts-table
	class="mt-1"
	:stationId="stationId"
	:time-from="dayStart(subtractHoursFromNowDate(24))"
	:time-to="dayEnd(new Date())"
/>
</template>


<script>
import AlertsTable from '@/components/AlertsView/AlertsTable.vue'
import { dayStart, dayEnd, subtractHoursFromNowDate } from '@/helpers.js'


export default {
	components: {
		AlertsTable,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		return {
			dayStart,
			dayEnd,
			subtractHoursFromNowDate,
		}
	},

	data() {
		return {
		}
	},

	async created() {},

	async mounted() {},

	beforeUnmount() {},

	methods: {},

	computed: {},
}
</script>


<style scoped>
</style>